<template>
    <pm-custom-dialog v-if="visible" v-model="visible" :onClose="onClose">


        <!-- <div style="background: url(/images/onboarding/onboarding-logo.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: -80px 0px 20px 0; width: 100%; height: 200px;"></div> -->

        <div style="margin-bottom: 16px; text-align: center; font-weight: 600; ">
            <h2 style="font-size: 28px; line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">YOU WON!</h2>
            <img src="/images/discount70.png" style="max-width: 95%;" />
        </div>

        <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">
            <div style="display: flex; text-align: left; justify-content: center; align-items: center; line-height: 1.1; ">
                <img style="width: 46px; height: 46px; margin: 7px 10px 0 0;" alt="DentiCalc" src="/images/dc_4in1_150_150.png">
                <div>
                    <span style="font-size: 22px;">
                        DentiCalc PREMIUM
                    </span>
                    <br/>
                    <strike style="font-size: 18px; display: inline-block; margin-right: 10px; font-weight: 600;">{{origPrice}}</strike> <span style="font-weight: 600;">{{introPrice}}/month</span>
                </div>
            </div>

            <pm-iap-product-button :sku="selectedSku" overrideTitle="CONTINUE" style="margin: 20px auto 0 auto;" />

            <div style="padding: 20px 40px;">
                <div style="line-height: 1.3; font-size: 13px;">
                    {{ $t('payment.cancel_subscription') }}

                    <pm-privacy-links />
                </div>
            </div>
        </p>
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
import PmIapProductButton from "@/components/core/iap-product-button.vue";
import PmPrivacyLinks from "../addons/privacy-links";
export default {
    components: {
        PmCustomDialog,
        PmIapProductButton,
        PmPrivacyLinks
    },
    data: () => ({
        visible: false,
        selectedSku: window.IAP.getDefaultSku(),
    }),
    created() {
        this.registerBusEvent('subscribe:process', this.changeProcessStatus);
    },
    mounted() {
        const audio = new Audio('https://cdn.denticalc.com/audio/win.mp3');
        audio.play();
    },
    computed: {
        origPrice() {
            const product = IAP.getProduct(this.selectedSku);
            return IAP.getProductPrices(product);
        },
        introPrice() {
            const product = IAP.getProduct(this.selectedSku);
            return IAP.getIntroPrice(product);
        },
    },
    methods: {
        changeProcessStatus(data) {
            this.visible = Boolean(data);
        },
        show() {
            this.visible = true;
            this.logDialogView();
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
        logDialogView() {
            const interestedToUpgrade = parseInt(localStorage.getItem('interestedToUpgrade') || '0', 10) + 1;

            localStorage.setItem('interestedToUpgrade', String(interestedToUpgrade));

            window.Tracker.logEvent({
                event_label: 'interestedToUpgrade',
                event_name: 'interested_to_upgrade',
                event_value: interestedToUpgrade,
            });
        },
        async gotoSubscriptionsAndRestorePurchases() {
            const params = {task: 'restore_purchases'};

            try {
                await this.goToRoute('addons', params);
            } catch (error) {
                captureException(error);
            }
        },

        onClose() {
            this.$bus.$emit('openAppDialog','discountRefuse');
        },

        async goToRoute(routeName, params = null) {
            this.close();
            await this.$router.push({name: routeName, params});
        },
    }
}
</script>
